import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EventComponent } from './event/event.component';
import { SpeakerComponent } from './speaker/speaker.component';

const routes: Routes = [
  {path: 'events', component:EventComponent},
  {path: 'speaker/:id', component:SpeakerComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EventManagementRoutingModule { }
